<template>
	<div v-if="site && engine && revision" class="page-print">
		<div class="page-header">
			<div>
				<h3 class="m-0"><b>ITALMOTORI</b> s.r.l. </h3>
				
			</div>
			<div>
				<p class="huge text-center">
					<b>
						REPORT INTERVENTO TECNICO
						<br> N° {{ revision.number }}
						<span style="margin-left: 0.75rem;">DEL : {{ revision.revisionDate | moment('DD/MM/YYYY') }}</span>
					</b>
				</p>
			</div>
			<p>
				Sede legale: Corso Milano, 83 - 35139 Padova (PD)<br>
				Ufficio e deposito: via Matteotti, 4/1 <br>
				35020 Z.I. Arzergrande (PD)<br>
				Tel. 049 9724315- Fax 049 9724665
			</p>


		</div>
		<div class="page-footer"></div>
		
		<table>
			<thead>
			  <tr>
				<td>          
				  <div class="page-header-space"></div>
				</td>
			  </tr>
			</thead>

			<tbody>
			  <tr>
				<td>
				<!-- page -->
					<div class="page">
						<print-revision-header 
							:revision="revision"
							:site="site"
							:engine="engine"
							/>
						<hr>

						<print-worked-details 
							:calculate="calculateTotalOfWorkedDeatails"
							:revision="revision" /> 


						<hr v-if="revision.anomalyDescription || revision.activityDescription">

						<print-activity-details 
							:revision="revision" />

						<hr>
						<div v-if="revision.productsUsed" class="data-table">
							<p style="margin: 1.25rem 0;"><b>PRODOTTI UTILIZZATI</b></p>
							<table class="table-print final-product-table">
								<thead>
									<tr>
										<th>codice</th>
										<th>descrizione</th>
										<th>quantità</th>
										<th>costo unitario</th>
										<th>totale</th>
									</tr>
								</thead>
								<tbody>
									<tr 
										v-for="(product,$index) in revision.productsUsed"
										v-if="productToShow(product)"
										:key="$index">

										<td>{{ product.code }}</td>
										<td>{{ product.description }}</td>
										<td>
											<div v-if="product.quantity">{{ product.quantity | qtaFilter(3) }}</div>
										</td>		
										<td v-if="product.singleAmount">{{ product.singleAmount | qtaFilter(3) }} €</td>
										<td v-else></td>
										<td v-if="product.totalAmount"><b>{{ product.totalAmount | currencyStringFilter }} €</b>
										</td>
										<td v-else></td>
									</tr>
									<tr>
										<td colspan="4">
											<b>Totale</b>
										</td>
										<td>
											<b>
												{{ productsTotal | currencyFilter  }} €
											</b>
										</td>
									</tr>
								</tbody>
							</table>
							<br>
						</div> 
						<hr  v-if="revision.productsUsed">
						<div class="data-table direction-row-reverse client">
							<div class="client-note">
								<p style="font-weight: bold;margin: 1.25rem 0;"><b>Note del cliente</b></p>
								<p v-html="printText(revision.clientsNote)" />
							</div>
							<div class="ita-signature  ital-sign">
								<b>Firma Responsabile Tecnico</b> <br>
								Alessandro Badio
								<!-- <img src="/img/Firma_Badio.jpg" alt="" style="max-width:300px"> -->
							</div>
							<div class="total-revision text-left"> <!-- nessun firma nell'amministrativa -->
								<div>
									<span><b>Totale intervento</b></span>
									<h3>{{total | currencyFilter}} €</h3>
								</div>
							</div>
						</div>
					</div>
					<!-- page -->
					<div class="page">
						<h6 class="text-right" style="opacity: 0">2/3</h6>
						<div class="data-table mb-0">
							<p><b><br>RELAZIONE DI INTERVENTO</b></p>
						</div>	
						<div class="data-table tech-details mt-3 mb-2">
							
							<div class="detail">
								<span>Filtro Aria</span>
								<p>{{ revision.techinicalDetails.airFilter }}</p>
							</div>
					
					
							<div class="detail">
								<span>Filtro Olio</span>
								<p>{{ revision.techinicalDetails.oilFilter }}</p>
							</div>
					
					
							<div class="detail">
								<span>Consumo olio lt</span>
								<p>{{ revision.techinicalDetails.oilConsumption }}</p>
							</div>
					
					
							<div class="detail">
								<span>Candele</span>
								<p>{{ revision.techinicalDetails.sparkPlugs }}</p>
							</div>
					
					
							<div class="detail">
								<span>Regolazione Punterie</span>
								<p>{{ revision.techinicalDetails.tappetsRegolation }}</p>
							</div>
					
					
							<div class="detail">
								<span>Controllo Batterie</span>
								<p>{{ revision.techinicalDetails.batteriesControl }}</p>
							</div>
					
					
							<div class="detail">
								<span>Pressione motore mBar</span>
								<p>{{ revision.techinicalDetails.engineBackPressure }}</p>
							</div>
					
					
							<div class="detail">
								<span>Compressore - olio</span>
								<p>{{ revision.techinicalDetails.compressor }}</p>
							</div>
					
					
							<div class="detail">
								<span>Compressore - condensa</span>
								<p>{{ revision.techinicalDetails.checkCondensateDrain }}</p>
							</div>
					
					
							<div class="detail">
								<span>Alternatore</span>
								<p>{{ revision.techinicalDetails.alternator }}</p>
							</div>
					
					
							<div class="detail">
								<span>Carburazione ossigeno % a massimo carico</span>
								<p>{{ revision.techinicalDetails.oxygenCarburation }}</p>
							</div>
					
					
							<div class="detail">
								<span>Controllo Sfondamenti</span>
								<p>{{ revision.techinicalDetails.breakthroughControl }}</p>
							</div>
					
					
							<div class="detail">
								<span>Pulizia Filtri Glicole</span>
								<p>{{ revision.techinicalDetails.glycolFilterCleaning }}</p>
							</div>
					
					
							<div class="detail">
								<span>Filtro Blow-By</span>
								<p>{{ revision.techinicalDetails.blowByFilterCleaning }}</p>
							</div>
					
					
							 <div class="detail">
								<span>Glicole motore - concentrazione </span>
								<p>{{ revision.techinicalDetails.glycolEngine }}</p>
							</div>
					
					
							<div class="detail">
								<span>Glicole intercooler - concentrazione</span>
								<p>{{ revision.techinicalDetails.glycolIntercooler }}</p>
							</div>

							<div class="detail">
								<span>Verifica pressione livello circuito principale</span>
								<p>{{ revision.techinicalDetails.pressureLevelOrH2OLevels }}</p>
							</div>
					
					
							<div class="detail">
								<span>Verifica pressione livello circuito secondario</span>
								<p>{{ revision.techinicalDetails.pressureLevelOrH2OLevelsCommment }}</p>
							</div>

						</div>
					</div>
					<div class="page">
						<h6 class="text-right" style="opacity: 0">2/3</h6>
						<div class="data-table tech-details mt-3 mb-2">
							<p class="w-100 mb-4"><b>CONTRO PRESSIONI ALLO SCARICO</b></p>
						
							<table class="table-pressure">
								<thead>
									<tr>
										<th></th>
										<th class="text-center">
											In recupero mbar +
										</th>
										<th  class="text-center">
											In atmosfera mbar +
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="text-center">
											Bancata Sinistra
										</td>
										<td class="text-center">
											{{ revision.techinicalDetails.leftExhaustBackPressureRecoverMBar }}
										</td>
										<td class="text-center">
											{{ revision.techinicalDetails.leftExhaustBackPressureAtmMBar }}
										</td>
									</tr>
									<tr>
										<td class="text-center">
											Bancata Destra
										</td>
										<td class="text-center">
											{{ revision.techinicalDetails.rightExhaustBackPressureRecoverMBar }}
										</td>
										<td  class="text-center">
											{{ revision.techinicalDetails.rightExhaustBackPressureAtmMBar }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<h6 class="text-right" style="opacity: 0">2/3</h6>
						<div class="data-table tech-details mt-3 mb-3">
								<div class="detail">
									<span>Kw motore</span>
									<p>{{ revision.techinicalDetails.engineKw }}</p>
								</div>
						
						
								<div class="detail">
									<span>Ch4</span>
									<p>{{ revision.techinicalDetails.ch4 }}</p>
								</div>
						
						
								<div class="detail">
									<span>Verifica perdite acqua/olio</span>
									<p>{{ revision.techinicalDetails.oilWaterLeakCheck }}</p>
								</div>
						
												
								<div class="detail">
									<span>Verifica emissioni CO</span>
									<p>{{ revision.techinicalDetails.o2emissionsCheck }}</p>
								</div>
						
												
								<div class="detail">
									<span>Pulizia ventole di estrazione</span>
									<p>{{ revision.techinicalDetails.cleanEngineLocalExhaustFans }}</p>
								</div>


						
								<div class="detail">								
									<span>Verifica termometri/manometri</span>
									<p>{{ revision.techinicalDetails.checkThermometers }}</p>
								</div>
						
						
								<div class="detail">
									<span>Ingrassaggio cuscinetti valvola fumi</span>
									<p>{{ revision.techinicalDetails.greasingSmokeValve }}</p>
								</div>
						
						
								<div class="detail">
									<span>Verifica funzionamento manuale / controllo rumori cuscinetti</span>
									<p>{{ revision.techinicalDetails.checkPumpsCabinSounds }}</p>
								</div>
						
						
								<div class="detail">
									<span>Verifica / pulizia radiatori</span>
									<p>{{ revision.techinicalDetails.checkAndCleanRadiatorPack }}</p>
								</div>
						
						
								<div class="detail">
									<span>Verifica funzionamento ventole radiatore</span>
									<p>{{ revision.techinicalDetails.checkRadiatorFans }}</p>
								</div>
								<div class="detail">
									<span>Verifica stato marmitte</span>
									<p>{{ revision.techinicalDetails.checkMufflers }}</p>
								</div>
						
						
								<div class="detail">
									<span>Verifica apertura scarichi scambiatore fumi</span>
									<p>{{ revision.techinicalDetails.checkSmokeExchanger }}</p>
								</div>
						
						
								<div class="detail">
									<span>verifica presenza glicole puro(litri)</span>
									<p>{{ revision.techinicalDetails.checkGlycolsLiters }}</p>
								</div>
						
						
								<div class="detail">
									<span>verifica presenza miscela acqua/glicole(litri)</span>
									<p>{{ revision.techinicalDetails.checkWaterGlycolsLiters }}</p>
								</div>
						
						
								<div class="detail">
									<span>olio lubrificante nuovo(litri)</span>
									<p>{{ revision.techinicalDetails.stockLubricatingOil }}</p>
								</div>
						
						
								<div class="detail">
									<span>olio lubrificante nel serbatoio(litri)</span>
									<p>{{ revision.techinicalDetails.stockLubricatingOilonLubeOile }}</p>
								</div>
															
						
								<div class="detail">
									<span>olio lubrificante nel fusto rabboccatore ad aria(litri)</span>
									<p>{{ revision.techinicalDetails.stockLubricatingOilonToppingUpAir }}</p>
								</div>
						</div>
					</div>
					<!-- page -->
					<div class="page">
						<h6 class="text-right" style="opacity: 0">2/3</h6>
						<div class="data-table tech-details mt-3">
							<p class="w-100 mb-4"><b>OPERAZIONI ESEGUITE SU RICHIESTA</b></p>
							<div class="detail">
								<span>necessita di svuotare cisterna olio</span>
								<p>{{ revision.techinicalDetails.mustEmptyOilTank }}</p>
							</div>

							<div class="detail">
								<span>Presenza olio nel condotto intercooler</span>
								<p>{{ revision.techinicalDetails.checkAbsenceOilOnIntercooler }}</p>
							</div>

							<div class="detail">
								<span>Verifica endoscopica sedi valvole e stato canne</span>
								<p>{{ revision.techinicalDetails.checkEndoscopicValvesAndTubes }}</p>
							</div>

							<div class="detail">
								<span>verifica usura testate</span>
								<p>{{ revision.techinicalDetails.checkEngineHeads }}</p>
							</div>
						
							<div class="detail">
								<span>effettuare prova di compressione e temperature</span>
								<p>{{ revision.techinicalDetails.checkCompressorAndTemperatures }}</p>
							</div>
							<div class="detail">
								<span>Verifica pressione di carica vasi e tenuta membrana (a pressione zero)</span>
								<p>{{ revision.techinicalDetails.checkVasisPressure }}</p>
							</div>
						</div>
						<!-- <div class="data-table my-2">
							<p><b>PISTONI</b></p>
						</div> -->	
						<div class="data-table tech-details mt-3">
							<div class="piston-row">
								<p style="min-width: 100px">
									<b>PISTONI</b>
								</p>								
								<div class="press small text-right">
									Pressione <br>
								</div>
								<div class="temp small text-right">
									Temperatura <br>
								</div>
							</div>
							<div class="piston-row">
								<p style="min-width: 100px">
								</p>								
								<div class="press small text-right">
									Pressione <br>
								</div>
								<div class="temp small text-right">
									Temperatura <br>
								</div>
							</div>
							<div class="piston-row"
								v-for="(pistonNumber,$index) in pistonsArray" :key="$index">
								<p> PISTONE {{ pistonNumber }} </p>
								<p class="press">{{ revision.techinicalDetails[`piston${pistonNumber}Pressure`] }}</p>
								<p class="temp">{{ revision.techinicalDetails[`piston${pistonNumber}Temperature`] }}</p>
							</div>
						</div>	
					</div>
				</td>
			  </tr>
			</tbody>

			<tfoot>
			  <tr>
				<td>
				  <div class="page-footer-space"></div>
				</td>
			  </tr>
			</tfoot>

		</table>

		<!-- <pre>{{revision.workedDetails}}</pre> -->

		<!-- 

			<div style="margin: auto; padding: 3rem; max-width: 1250px;"> 

				<h6>site</h6>

				<pre>{{site}}</pre>

				<h6>engine</h6>

				<pre>{{engine}}</pre>  

				<h6>revision</h6>

				<pre>{{revision}}</pre>

				<h6>Dettaglio ore</h6>

				<pre>{{revision.workedDetails}}</pre>

				<h6>Prodotti</h6>

				<pre>{{revision.productsUsed}}</pre> 

			</div> 
		-->
	</div>
  <loading v-else />
</template>

<style lang="scss" scoped>
</style>
<script>
	
import { mapState, mapActions } from 'vuex'
import PrintWorkedDetails from './WorkedDetails.vue'
import PrintActivityDetails from './ActivityDetails.vue'
import PrintRevisionHeader from './RevisionHeader.vue'

export default{
	components:{
		PrintWorkedDetails,
		PrintRevisionHeader,
		PrintActivityDetails
	},
  	computed: {
		...mapState({
			revisions: state => state.revisions.revisions,
			site: state => state.sites.site,
			revision: state => state.revisions.revision,
			engine: state => state.engines.engine,
			loading: state => state.engines.loading,
			user: state => state.account.user,
		}),
		productsTotal() {
			let total = 0;
			this.revision.productsUsed.forEach(product => {
				if (product.totalAmount !== undefined){
					total = total + parseFloat(product.totalAmount)
				}
				console.log(total)
			})
			return total
		},
		total() {
			//totale dato da 
			// calculateTotalOfWorkedDeatails per ogni key:
				// workedHours
				// holidayWorkedHours: Number,
				// tripHours: Number,
				// diem: Number,
				// overNight: Number,
				// totalKmTrip: Number,
			const workedDetailsKeys = ['workedHours', 'holidayWorkedHours', 'tripHours', 'diem', 'overNight', 'totalKmTrip'];
			let workedDetailsTotal = 0;
			workedDetailsKeys.forEach(key => {
				workedDetailsTotal += parseFloat(this.calculateTotalOfWorkedDeatails(key));
			})


			// Somma di tutte le model.workedDetails.additionalLines[i].amount
			let additionalLinesTotal = 0;
			this.revision.workedDetails.additionalLines.forEach(line => {
				if (line.amount && ! isNaN(line.amount)){
					additionalLinesTotal += parseFloat(line.amount)
				}
			})

			// somma di tutti i prodotti
			// model.productsUsed[i].totalAmount
			let productsTotal = 0;
			this.revision.productsUsed.forEach(product => {
				if ( product.totalAmount && ! isNaN(product.totalAmount)){
					productsTotal += parseFloat(product.totalAmount);
				}
			})

			// return workedDetailsTotal+productsTotal+additionalLinesTotal;
			return (workedDetailsTotal+productsTotal+additionalLinesTotal);
		},
  	},
	async mounted() {
		const {engineId, id} = this.$route.params;
		await this.get({engineId, id})
		this.getEngine({id: engineId})
	},
	watch: {
		engine: function(newValue) {
			if (newValue !== null){
			this.getSite(newValue.site)
			}
		},
		site: function(newValue){
			if (newValue && newValue.id){
				setTimeout(() => {
					window.print()
				},300);
			}
		},
		async $route(from,to) {
			const {engineId, id} = this.$route.params;
			await this.get({engineId, id})
			this.getEngine({id: engineId})
		}
	},
	data() {
		return {
			pistonsArray: [...Array(16)].map(( u,i ) => i + 1 )
		}
	},
	methods: {
		...mapActions('engines', {
			getEngine: 'get'
		}),
		...mapActions('sites', {
			getSite: 'get'
		}),
		...mapActions('revisions', {
			get: 'get',
			update: 'update'
		}),
		productToShow(product) {
			return product.code ||
				product.description|| 
				product.quantity||
				product.singleAmount;
		},
		calculateTotalOfWorkedDeatails(key){
			let sum = 0;
			this.revision.workedDetails.days.forEach(day => {
				sum = day[key] ? sum + parseFloat(day[key]) : sum;
			})
			const total = parseFloat(this.revision.workedDetails.detailsSingleAmount[key]) * sum;
			return isNaN(total) ? 0 : total;
		},
		printText(val){
			return val ?  val.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''
		}
	},
}	
</script>